<wbo-edit-page #editPage [formGroup]="editPage.formGroup" [title]="model.data.name" (addingAnother)="addingAnother($event)">
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.inventory.edit.formation.inventoryDetails', formControlNames: ''}">
        <wbo-inventory-edit-details></wbo-inventory-edit-details>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.inventory.edit.formation.customGroups', formControlNames: 'customObjectContext'}">
        <fui-rows>
            <fui-row>
                <fui-two-columns [formGroup]="editPage.formGroup">
                    <fui-column formGroupName="customObjectContext">
                        <wbo-custom-object-multi-select-edit-control formControlName="customObjects"
                                                                     [inventoryContext]="true"
                                                                     [(ngModel)]="model.data.customObjectContext.customObjects">
                        </wbo-custom-object-multi-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.inventory.edit.formation.inventoryLocation', formControlNames: 'outletStocks'}">
        <wbo-inventory-edit-location></wbo-inventory-edit-location>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.inventory.edit.formation.inventoryRecipe', formControlNames: 'recipeItems'}">
        <wbo-inventory-edit-recipe></wbo-inventory-edit-recipe>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.inventory.edit.formation.inventoryBarcodes', formControlNames: 'barcodes'}">
        <wbo-inventory-edit-barcode></wbo-inventory-edit-barcode>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.inventory.edit.formation.details', formControlNames: 'details'}">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-textarea-edit-control formControlName="details"
                                                   [(ngModel)]="model.data.details"></wbo-textarea-edit-control>
                    </fui-column>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-text-edit-control formControlName="sku"
                                                   [(ngModel)]="model.data.sku"></wbo-text-edit-control>
                            <wbo-text-edit-control formControlName="source"
                                                   [(ngModel)]="model.data.source" [readonly]="true"></wbo-text-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
</wbo-edit-page>
